import React, { useEffect } from 'react';

import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import AccessInfoSelector from '../../recoil/selectors/AccessInfoSelector';
import Loading from '../general/Loading';
import RewardsRoutes from '../rewards/RewardsRoutes';
import ClaimRewardsNavbar from '../rewards/common/ClaimRewardsNavbar';
import { handleBack } from '../helpers/BrowserHelper';

export default function RewardsLayout() {
  const { ready } = useTranslation(null, { useSuspense: false });
  const { network } = useRecoilValue(AccessInfoSelector);

  const { t } = useTranslation();

  useEffect(() => {
    // eslint-disable-next-line no-undef
    document.title = t('landing_page_window_title');
  }, [t]);

  if (!ready) {
    return <Loading />;
  }

  return (
    <div className="main-layout">
      <div className={`container ${network} purchase`}>
        <div className="ui-bootstrap">
          <div id="global-layer-header">
            <ClaimRewardsNavbar onClose={handleBack} />
          </div>
        </div>
        <div id="global-layer-main" className="container viewport-constraint-inherit">
          <div id="global-layer-main-content">
            <div
              className="global-layer-main-constraint viewport-constraint-inherit"
              style={{ position: 'static', top: 'auto', bottom: 'auto' }}
            >
              <div className="global-layer ui-bootstrap member-diamonds-conversion-loading main-content-container">
                <RewardsRoutes />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="modal-container" className="ui-bootstrap" />
    </div>
  );
}
